<template>
	<div class="container">
		<gaode-map ref="myMap" :ifComponent="false" :addressInfo="$route.params.addressInfo"></gaode-map>
	</div>
</template>

<script>
import GaodeMap from '../../GaodeMap'
export default {
  components: {
	  GaodeMap
  },

  data () {
    return {

    }
  },
  created: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
